var cerubi_open = false;
var cerubi_started = false;
var cerubi_product = null;

// ── SEURANTA ──
function cerubi_track(event, detail){
  try {
    var key = 'cerubi_stats';
    var data = JSON.parse(localStorage.getItem(key)||'{}');
    if(!data.events) data.events = [];
    data.events.push({e:event, d:detail||'', t:new Date().toISOString()});
    if(!data.counts) data.counts = {};
    var ck = event+(detail?'_'+detail:'');
    data.counts[ck] = (data.counts[ck]||0)+1;
    localStorage.setItem(key, JSON.stringify(data));
  } catch(err){}
}

var CERUBI_P = {
  sofie: {name:'Sofie',url:'https://cerubi.fi/products/sofie-pellavamekko-beige',lt:'Katso Sofie-mekot'},
  rosa: {name:'Rosa',url:'https://cerubi.fi/products/rosa-pellavamekko-sinivihrea',lt:'Katso Rosa-mekot'},
  sara: {name:'Sara',url:'https://cerubi.fi/products/sara-pellavamekko-valkoinen',lt:'Katso Sara-mekot'},
  marie: {name:'Marie',url:'https://cerubi.fi/products/marie-pellavamekko-siniharmaa',lt:'Katso Marie-mekot'},
  bella: {name:'Bella',url:'https://cerubi.fi/products/bella-pellavamekko-punainen',lt:'Katso Bella-mekot'},
  marie_t: {name:'Marie-tunika',url:'https://cerubi.fi/products/marie-pellavatunika-roosa',lt:'Katso Marie-tunikat'},
  lily: {name:'Lily',url:'https://cerubi.fi/products/lily-pellavatunika-sinivihrea',lt:'Katso Lily-tunika'}
};

var CERUBI_I = {
  sofie:'Suosittelen sinulle Sofie-mekkoa.',
  rosa:'Vastauksiesi perusteella Rosa voisi olla juuri sinun tyylisesi.',
  sara:'Uskon, että viihtyisit erityisen hyvin Sara-mekossa.',
  marie:'Suosittelen sinulle Marie-mekkoa.',
  bella:'Vastauksiesi perusteella Bella voisi olla juuri sinun tyylisesi.',
  marie_t:'Uskon, että viihtyisit erityisen hyvin Marie-tunikassa.',
  lily:'Suosittelen sinulle Lily-tunikaa.'
};

var CERUBI_D = {
  sofie:'Sofie on Cerubin väljin mekkomalli ja yksi pisimmistä malleistamme. Pyöreä pääntie, täyspitkät hihat ja väljä istuvuus tekevät Sofiesta huolettoman kumppanin koko päiväksi. Naisellinen frillahelma tuo pehmeyttä.\n\n🌸 Ihana valinta, kun arvostat väljyyttä ja huoletonta naisellisuutta.',
  rosa:'Rosa on kevyt, naisellinen ja huoleton kesämekko kauniisti laskeutuvalla A-linjaisella mallilla. Joustava pääntie tekee siitä miellyttävän käyttää.\n\n🌸 Ihana valinta, kun haluat tuntea olosi kauniiksi ja itsevarmaksi.',
  sara:'Sara on yksi Cerubin rakastetuimmista malleista. Joustavan pääntien voi laskea myös olkapäille. A-linjainen malli tuntuu mukavalta koko päivän.\n\n🌸 Ihana valinta, kun pidät naisellisesta tyylistä.',
  marie:'Marie on ajaton ja naisellinen mekko kauniilla laskoksilla pääntiellä ja olkapäillä. Selän kauluspaitalaskos lisää mukavuutta.\n\n🌸 Ihana valinta, kun arvostat ajattomuutta ja kauniita yksityiskohtia.',
  bella:'Bella on yksi pisimmistä malleistamme. Kauniisti rypytetty pääntie ja frillakoriste tuovat naisellista pehmeyttä. Täyspitkät hihat tekevät siitä monikäyttöisen.\n\n🌸 Ihana valinta, kun pidät pitkästä ja huolitellusta tyylistä.',
  marie_t:'Marie-tunikassa on sama rakastettu ilme kuin Marie-mekossa. Kauniit laskokset pääntiellä ja selän kauluspaitalaskos tekevät siitä naisellisen.\n\n🌸 Ihana valinta, kun etsit naisellista luottovaatetta.',
  lily:'Lily on kuin kesäinen tuulahdus kukkaniityltä. Rento, väljä ja helppo pukea. Frillat hihansuissa ja laskokset pääntiellä tekevät siitä viehättävän.\n\n🌸 Ihana valinta, kun kaipaat rentoa kesätunnelmaa. Yhden koon malli!'
};

var CERUBI_FAQ = [
  {q:'Mikä koko minulle?',a:'Koot menevät näin: koko 1 on 42/44, koko 2 on 46/48, koko 3 on 50/52 ja koko 4 on 54/56. Jos et ole varma, stylisti auttaa sinua löytämään oikean!'},
  {q:'Sopiiko mekko minulle?',a:'Siitä tiedät, että se tuntuu hyvältä heti. Ei sisäänajoa, ei kikkailua. Mekkojemme mallit on suunniteltu laskeutumaan kauniisti.'},
  {q:'Milloin mekko saapuu?',a:'Postitamme jokaisena arkipäivänä. Toimituskulut Suomeen ovat 6,50 € postin toimipisteisiin.'},
  {q:'Entä jos mekko ei miellytä?',a:'Ei hätää. Voit palauttaa käyttämättömän mekon 14 päivän sisällä veloituksetta. Ota yhteyttä osoitteeseen info@cerubi.fi.'},
  {q:'Miten pellava pestään?',a:'40 astetta, hellävarainen ohjelma, nestemäinen pesuaine ja vaate nurinnäin. Huuhteluaine jää kaappiin. Suorista heti pesun jälkeen. Rypyt ovat osa pellavan viehätystä — jos silität, tee se kosteana nurjalta puolelta kahden pisteen lämmöllä.'},
  {q:'Onko teillä myymälää?',a:'Ei ole — olemme täysin verkossa. Sähköpostimme info@cerubi.fi on auki ja vastaamme mielellämme. Oikea ihminen, ei robotti!'}
];

function cerubi_toggle(){
  cerubi_open = !cerubi_open;
  var w = document.getElementById('cerubi-w');
  if(cerubi_open){w.className='open';cerubi_track('avaus');}else{w.className='';}
  if(cerubi_open && !cerubi_started){cerubi_started=true;setTimeout(cerubi_start,300);}
}

function cerubi_msgs(){return document.getElementById('cerubi-msgs');}
function cerubi_scroll(){setTimeout(function(){cerubi_msgs().scrollTop=cerubi_msgs().scrollHeight;},60);}

function cerubi_bot(html, delay){
  return new Promise(function(res){
    setTimeout(function(){
      var d=document.createElement('div');
      d.className='cw-bot cw-anim';
      d.innerHTML=html.split('\n').join('<br>');
      cerubi_msgs().appendChild(d);
      cerubi_scroll();res();
    },delay||0);
  });
}

function cerubi_user(text){
  var d=document.createElement('div');
  d.className='cw-usr';
  d.textContent=text;
  cerubi_msgs().appendChild(d);
  cerubi_scroll();
}

function cerubi_disable(){
  var btns=document.querySelectorAll('.cw-opt');
  for(var i=0;i<btns.length;i++){btns[i].disabled=true;}
}

function cerubi_opts(opts, delay){
  return new Promise(function(res){
    setTimeout(function(){
      var w=document.createElement('div');
      w.className='cw-opts';
      opts.forEach(function(o){
        var b=document.createElement('button');
        b.className='cw-opt';
        b.textContent=o.label;
        b.onclick=function(){cerubi_disable();cerubi_user(o.label);o.action();};
        w.appendChild(b);
      });
      cerubi_msgs().appendChild(w);
      cerubi_scroll();res();
    },delay||0);
  });
}

function cerubi_show_product(key, delay){
  return new Promise(function(res){
    setTimeout(function(){
      var p=CERUBI_P[key];
      cerubi_product=p;
      cerubi_track('malli', key);
      var card=document.createElement('div');
      card.className='cw-card';
      var name=document.createElement('div');
      name.className='cw-cn';
      name.textContent=p.name;
      var desc=document.createElement('div');
      desc.className='cw-cd';
      desc.innerHTML=CERUBI_D[key].split('\n').join('<br>');
      var link=document.createElement('a');
      link.className='cw-cl';
      link.href=p.url;
      link.target='_blank';
      link.textContent='Katso '+p.lt;
      link.onclick=function(){cerubi_track('tuoteklikkaus', key);};
      card.appendChild(name);
      card.appendChild(desc);
      card.appendChild(link);
      cerubi_msgs().appendChild(card);
      cerubi_scroll();res();
    },delay||0);
  });
}

function cerubi_size_card(text, delay){
  return new Promise(function(res){
    setTimeout(function(){
      var card=document.createElement('div');
      card.className='cw-sz';
      var b=document.createElement('b');
      b.textContent='Kokosuositus';
      var t=document.createTextNode(' 🌸 '+text);
      card.appendChild(b);
      card.appendChild(t);
      cerubi_msgs().appendChild(card);
      cerubi_scroll();res();
    },delay||0);
  });
}

function cerubi_end(delay){
  cerubi_bot('🌸 Olemme mielellämme avuksi myös sähköpostitse: info@cerubi.fi', delay||0).then(function(){
    setTimeout(function(){
      var btn=document.createElement('button');
      btn.className='cw-re';
      btn.textContent='Aloita alusta';
      btn.onclick=function(){
        cerubi_msgs().innerHTML='';
        cerubi_started=false;
        cerubi_product=null;
        cerubi_track('aloita_alusta');
        cerubi_start();
      };
      cerubi_msgs().appendChild(btn);
      cerubi_scroll();
    },400);
  });
}

function cerubi_size_flow(){
  cerubi_bot('🌸 Varmistetaan vielä oikea koko. Mikä on tavallinen vaatekokosi?',400).then(function(){
    cerubi_opts([
      {label:'42–44',action:function(){cerubi_track('koko','42-44');cerubi_size_card('Suosittelen sinulle kokoa 1 (42/44).',400).then(function(){cerubi_end(800);});}},
      {label:'46–48',action:function(){cerubi_track('koko','46-48');cerubi_size_card('Suosittelen sinulle kokoa 2 (46/48).',400).then(function(){cerubi_end(800);});}},
      {label:'50–52',action:function(){cerubi_track('koko','50-52');cerubi_size_card('Suosittelen sinulle kokoa 3 (50/52).',400).then(function(){cerubi_end(800);});}},
      {label:'54–56',action:function(){cerubi_track('koko','54-56');cerubi_size_card('Suosittelen sinulle kokoa 4 (54/56).',400).then(function(){cerubi_end(800);});}},
      {label:'En ole varma',action:cerubi_size_by_measure}
    ],800);
  });
}

function cerubi_size_by_measure(){
  cerubi_bot('🌸 Eipä hätää. Kerro rinnanympäryksesi senttimetreinä.',400).then(function(){
    setTimeout(function(){
      var row=document.createElement('div');
      row.className='cw-inp';
      var inp=document.createElement('input');
      inp.type='number';
      inp.placeholder='esim. 130';
      var btn=document.createElement('button');
      btn.textContent='OK';
      var handle=function(){
        var v=parseInt(inp.value);
        if(isNaN(v))return;
        row.remove();
        cerubi_user(v+' cm');
        cerubi_track('rinnanymparys', v+'cm');
        var text;
        if(v<123){text='Suosittelen sinulle kokoa 1 (42/44)';}
        else if(v<=133){text='Suosittelen sinulle kokoa 2 (46/48).';}
        else if(v===134){text='Olet kahden koon rajalla. Valitsisin koon 3 (50/52), jos pidät huolettoman väljästä istuvuudesta.';}
        else if(v<=138){text='Suosittelen sinulle kokoa 3 (50/52).';}
        else if(v<=142){text='Olet kahden koon rajalla. Valitsisin koon 4 (54/56), jos pidät huolettoman väljästä istuvuudesta.';}
        else if(v<=146){text='Suosittelen sinulle kokoa 4 (54/56).';}
        else{text='Katsotaan yhdessä vaihtoehtoja. Olemme avuksi sähköpostitse: info@cerubi.fi.';}
        cerubi_size_card(text,400).then(function(){cerubi_end(800);});
      };
      btn.onclick=handle;
      inp.onkeydown=function(e){if(e.key==='Enter')handle();};
      row.appendChild(inp);
      row.appendChild(btn);
      cerubi_msgs().appendChild(row);
      cerubi_scroll();
    },800);
  });
}

function cerubi_recommend(key){
  cerubi_bot('🌸 '+CERUBI_I[key],400).then(function(){
    cerubi_show_product(key,800).then(function(){
      if(key==='lily'){cerubi_end(1200);}
      else{setTimeout(cerubi_size_flow,1200);}
    });
  });
}

function cerubi_mekko_tarkennus(){
  cerubi_bot('🌸 Mikä näistä kuulostaa eniten sinulta?',400).then(function(){
    cerubi_opts([
      {label:'Kevyt ja kesäinen',action:function(){cerubi_recommend('rosa');}},
      {label:'Naisellinen, olkapäille laskettavalla pääntiellä',action:function(){cerubi_recommend('sara');}},
      {label:'Ajaton ja huoliteltu',action:function(){cerubi_recommend('marie');}},
      {label:'Pitkähihainen ja elegantti',action:function(){cerubi_recommend('bella');}}
    ],800);
  });
}

function cerubi_mekkopolku(){
  cerubi_bot('🌸 Millaisessa mekossa viihdyt parhaiten?',400).then(function(){
    cerubi_opts([
      {label:'Mahdollisimman väljässä ja rennossa',action:function(){cerubi_recommend('sofie');}},
      {label:'Naisellisessa ja kauniisti laskeutuvassa',action:cerubi_mekko_tarkennus},
      {label:'En osaa sanoa',action:function(){
        cerubi_bot('🌸 Eipä hätää. Jokaisella mallilla on oma persoonallisuutensa.',400).then(function(){
          cerubi_mekko_tarkennus();
        });
      }}
    ],800);
  });
}

function cerubi_tunikapolku(){
  cerubi_bot('🌸 Millaisessa tunikassa viihdyt parhaiten?',400).then(function(){
    cerubi_opts([
      {label:'Mahdollisimman väljässä ja rennossa',action:function(){cerubi_recommend('lily');}},
      {label:'Naisellisessa ja huolitellussa',action:function(){cerubi_recommend('marie_t');}},
      {label:'En osaa sanoa',action:function(){cerubi_recommend('marie_t');}}
    ],800);
  });
}

function cerubi_faq(){
  cerubi_bot('🌸 Mistä haluaisit tietää lisää?',400).then(function(){
    cerubi_opts(CERUBI_FAQ.map(function(item){
      return {
        label:'❓ '+item.q,
        action:function(){
          cerubi_track('faq', item.q);
          cerubi_bot('🌸 '+item.a,300).then(function(){
            setTimeout(function(){
              cerubi_bot('🌸 Onko muuta kysyttävää?',600).then(function(){
                cerubi_opts([
                  {label:'Kyllä, kysyn vielä',action:cerubi_faq},
                  {label:'🌸 Etsin sopivaa mallia',action:cerubi_style_start},
                  {label:'Ei, kiitos!',action:function(){cerubi_end(400);}}
                ],1000);
              });
            },800);
          });
        }
      };
    }),800);
  });
}

function cerubi_style_start(){
  cerubi_bot('🌸 Lähdetään etsimään suosikkiasi. Kiinnostavatko sinua enemmän...',400).then(function(){
    cerubi_opts([
      {label:'Mekot',action:cerubi_mekkopolku},
      {label:'Tunikat',action:cerubi_tunikapolku},
      {label:'Molemmat',action:function(){
        cerubi_bot('🌸 Molemmat ovat ihania. Katsotaanko ensin mekot vai tunikat?',400).then(function(){
          cerubi_opts([
            {label:'Mekot',action:cerubi_mekkopolku},
            {label:'Tunikat',action:cerubi_tunikapolku}
          ],800);
        });
      }},
      {label:'En ole vielä varma',action:function(){
        cerubi_bot('🌸 Valinta ei ole aina helppo. Millaisessa vaatteessa viihdyt parhaiten?',400).then(function(){
          cerubi_opts([
            {label:'Mahdollisimman väljässä ja rennossa',action:function(){
              cerubi_bot('🌸 Aloitetaanko mekosta vai tunikasta?',400).then(function(){
                cerubi_opts([
                  {label:'Mekko',action:function(){cerubi_recommend('sofie');}},
                  {label:'Tunika',action:function(){cerubi_recommend('lily');}}
                ],800);
              });
            }},
            {label:'Naisellisessa ja laskeutuvassa',action:function(){
              cerubi_bot('🌸 Aloitetaanko mekosta vai tunikasta?',400).then(function(){
                cerubi_opts([
                  {label:'Mekko',action:cerubi_mekko_tarkennus},
                  {label:'Tunika',action:function(){cerubi_recommend('marie_t');}}
                ],800);
              });
            }},
            {label:'En osaa sanoa',action:cerubi_mekko_tarkennus}
          ],800);
        });
      }}
    ],800);
  });
}

function cerubi_start(){
  cerubi_bot('🌸 Ihanat mekot voivat tehdä valinnasta vaikean. Katsotaan yhdessä, mikä malli ja koko sopisivat sinulle parhaiten.',0).then(function(){
    cerubi_bot('Mitä voin tehdä sinulle tänään?',600).then(function(){
      cerubi_opts([
        {label:'🌸 Etsin sopivaa mallia',action:cerubi_style_start},
        {label:'❓ Minulla on kysyttävää',action:cerubi_faq}
      ],1000);
    });
  });
}